import { render, staticRenderFns } from "./CancelarConsultaBtn.vue?vue&type=template&id=61717eb3&scoped=true"
import script from "./CancelarConsultaBtn.vue?vue&type=script&lang=js"
export * from "./CancelarConsultaBtn.vue?vue&type=script&lang=js"
import style0 from "./CancelarConsultaBtn.vue?vue&type=style&index=0&id=61717eb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61717eb3",
  null
  
)

export default component.exports